module.exports = __webpack_public_path__ + "img/DSC_0027.b4d592db.jpg";